import React from 'react';

// types
import type {
  WThemeGroupSearchResultsView,
  WThemeSearchResultsView,
} from '@zola/svc-web-api-ts-client';

// styles
import {
  SwatchContainer,
  SwatchCountTxt,
  SwatchHalf,
  SwatchInnerContainer,
  SwatchRow,
} from './PLPThemeSwatches.styles';

type PLPThemeSwatchesProps = {
  themeOptions: WThemeGroupSearchResultsView;
  currentTheme: WThemeSearchResultsView;
  onSwatchClick: (
    e: React.MouseEvent,
    theme: WThemeSearchResultsView,
    localThemeGroupKey?: string
  ) => void;
};

const PLPThemeSwatches: React.FC<PLPThemeSwatchesProps> = ({
  themeOptions,
  currentTheme,
  onSwatchClick,
}) => {
  const onSwatchClickHandler = (
    e: React.MouseEvent,
    theme: WThemeSearchResultsView,
    localThemeGroupKey: string
  ) => {
    onSwatchClick(e, theme, localThemeGroupKey);
  };

  const isSelected = (theme: WThemeSearchResultsView) => {
    return theme.key === currentTheme.key;
  };

  const swatchesCount = themeOptions.themes.length;
  let themesList = themeOptions.themes;
  if (swatchesCount > 6) {
    themesList = themeOptions.themes.slice(0, 6);
  }

  const swatches = themesList.map((theme: WThemeSearchResultsView) => {
    const themeIdentifier = theme.key;
    return (
      <SwatchContainer
        active={isSelected(theme)}
        onClick={e => {
          if (themeOptions.themes?.[0].key) {
            onSwatchClickHandler(e, theme, themeOptions.themes[0].key);
          }
        }}
        key={`SwatchContainer-${themeIdentifier}`}
        data-testid="PLPThemeSwatches__Swatch"
      >
        <SwatchInnerContainer
          key={`SwatchInnerContainer-${themeIdentifier}`}
          color={`#${theme?.swatch_color}`}
        >
          <div>
            <SwatchHalf color={`#${theme?.swatch_color}`} />
            <SwatchHalf color={`#${theme?.swatch_color}`} />
          </div>
        </SwatchInnerContainer>
      </SwatchContainer>
    );
  });

  return (
    <SwatchRow mobileVisibility data-testid="PLPThemeSwatches">
      {swatches}
      {swatchesCount > 6 && <SwatchCountTxt>{` +${swatchesCount - 6}`}</SwatchCountTxt>}
    </SwatchRow>
  );
};

export default PLPThemeSwatches;
